import { useState, type ReactNode } from "react";

interface Props {
  title: string;
  id?: string;
  defaultOpen?: boolean;
  /** Liten text som visas i header även när collapsed, t.ex. nyckeltal. */
  summary?: string;
  children: ReactNode;
}

/**
 * Expanderbar sektion med rubrik. Default-tillstånd avgörs av defaultOpen
 * som komponentens användare kan styra (t.ex. öppen på desktop, stängd på
 * mobil). Tillåter användaren att skala ner mängden information på skärmen.
 */
export default function CollapsibleSection({
  title,
  id,
  defaultOpen = false,
  summary,
  children,
}: Props) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section className="collapsible-section" id={id}>
      <button
        type="button"
        className={`collapsible-header ${open ? "is-open" : "is-closed"}`}
        onClick={() => setOpen(!open)}
        aria-expanded={open}
      >
        <span className="collapsible-title">{title}</span>
        {summary && !open && (
          <span className="collapsible-summary">{summary}</span>
        )}
        <span className="collapsible-icon" aria-hidden>
          {open ? "−" : "+"}
        </span>
      </button>
      {open && <div className="collapsible-content">{children}</div>}
    </section>
  );
}
